<template>
  <div>
    <p>
      <span class="modal-body-text"
        >You are about to delete {{ name }} from {{ place }}.</span
      ><br /><br />
      <span v-if="data.deletePhase" class="modal-body-text"
        >All activities of this phase will be deleted.<br /><br
      /></span>
      <span class="modal-body-text">Are you sure you want to continue?</span>
      <br />
    </p>
  </div>
</template>

<script>
export default {
  name: "delete-activity-phase-modal",
  props: {
    data: null
  },
  computed: {
    name() {
      if (this.data.deleteActivity) {
        if (this.data.activityName && this.data.activityName.length > 0) {
          return `activity ${this.data.activityName}`;
        } else {
          return "an activity";
        }
      } else if (this.data.deletePhase) {
        if (this.data.order >= 0) {
          return `phase ${this.data.order + 1}`;
        } else {
          return "a phase";
        }
      }
    },
    place() {
      if (this.data.deleteFromLevel) {
        return "level";
      }
      return "program";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal/ConfirmDeletionActivityPhase.vue